import React from 'react'

const EducationButton = ({ activeTab, setActiveTab, handleVendorCheckOrCreate }) => {
    const extraScroll = window.innerWidth <= 990 ? 850 : 0;

    return (
        <div
            className={`tab-button ${activeTab === "education" ? "active" : ""
                }`}
            onClick={() => {
                setActiveTab();
                window.scrollTo({
                    top: window.innerHeight * 0.8 + extraScroll,
                    behavior: "smooth",
                });
                handleVendorCheckOrCreate();
            }}
        >
            <span className="education-svg">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="40"
                    height="40"
                    x="0"
                    y="0"
                    viewBox="0 0 349.2 349.2"
                    style={{ enableBackground: "new 0 0 512 512" }}
                    className=""
                >
                    <g>
                        <path
                            d="m337.6 114.25-139.2-68c-12-6-32.4-6-44.4 0l-142.4 68c-10 4.8-11.6 11.6-11.6 15.2 0 3.6 1.6 10 11.6 15.2l11.6 5.6v64c-7.2 2.8-12.4 10-12.4 18s5.2 15.2 12 18l-18 57.2h50.4l-18-57.2c7.2-2.8 12-10 12-18 0-8.4-5.2-15.2-12.4-18v-57.2l21.2 10.4v83.2c0 1.2.4 2.4 1.2 3.6 2 2.4 39.2 53.2 115.2 53.2s113.2-51.2 114.8-53.2c.8-1.2 1.2-2.4 1.2-3.6v-82.8l47.2-23.2c10-4.8 11.6-11.6 11.6-15.2-.4-3.6-1.6-10.4-11.6-15.2zm-60 134.4c-6.4 8-40.8 46.4-103.2 46.4-62.4 0-96.8-38.4-103.2-46.4v-75.6l82.8 39.6c6 2.8 14 4.4 22 4.4 8.4 0 16.4-1.6 22.4-4.8l79.2-38.8v75.2zm54.4-115.2-48 23.6c-2 0-3.6.8-4.4 2.4l-86.8 42c-8.4 4.4-24.8 4.4-33.6 0l-106.8-51.2 122.8-14.4c3.6-.4 6-3.6 5.6-6.8-.4-3.6-3.6-6-6.8-5.6l-142.4 16.8-14.4-6.8c-3.6-1.6-4.4-3.6-4.4-3.6 0-.4.8-2 4.4-3.6l142.4-68.4c4.4-2 10.4-3.2 16.4-3.2 6.4 0 12.8 1.2 16.8 3.2l139.2 68c3.6 1.6 4.4 3.2 4.4 4 0 0-1.2 2-4.4 3.6z"
                            fill="#414141"
                            opacity="1"
                        ></path>
                    </g>
                </svg>
            </span>
            <span>Education</span>
        </div>
    )
}

export default EducationButton